import axios from 'axios';
import config from '@/config/constants.js';

export default {
    namespaced: true,
    state: {
        status: '',
        services: [],
        slice_services: [],
        hide_other: false
    },
    mutations: {
        loading(state) {
            state.status = 'loading';
        },
        status(state, status) {
            state.status = status;
        },
        success(state) {
            state.status = '';
        },
        setHideOther(state, value) {
            state.hide_other = value;
        },
        addServices(state, services) {
            state.services = [];
            for (const prop in services) {
                state.services.push({
                    text: services[prop].name,
                    value: services[prop].name,
                });
            }
        },
        sliceServices(state, size) {
            state.slice_services = [];
            if (size !== 'all') {
                state.slice_services = state.services.slice(0, size);
            } else {
                state.slice_services = state.services;
            }

            if (!state.hide_other && state.slice_services.length > 12) {
                state.services.push({
                    text: 'Other',
                    value: ''
                });
            }
        }
    },
    actions: {
        segment_services({ commit }, size) {
            commit('sliceServices', size);
        },
        get_services: async function ({ commit, state }) {
            commit('loading');
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve) {
                const dataServices = await axios.get(config.api_url + 'servises');
                const datos = dataServices.data['servises'];
                commit('addServices', datos);
                commit('success');
                resolve(state.services);
            });
        },
    },
};